module.exports = __webpack_public_path__ + "img/Slice11-min.e7bcbfc8.png";